var map = {
	"./87OPEN TENDER FOR SELECTION.pdf": 91158,
	"./AM-Finpdf-71a8313df8e3a2ef09958395dc0f6836.pdf": 53177,
	"./AM-HRMpdf-ae8cee30d08b047ad8815c3d4907542a.pdf": 57865,
	"./AM-PLRpdf-3fca5f41588a95ea6a6e95eacbc03396.pdf": 40518,
	"./AM-Result-pdf-baa6887c73f81dd63a2b61abe5fec2cd.pdf": 51628,
	"./AMFAcctpdf-fd7da7d59784edfa0bedb7894243aff2.pdf": 51915,
	"./AMHRMpdf-5c0109aeac723f945b8f5fd2e94e7b6f.pdf": 99357,
	"./AMProjectCoordpdf-d4adbdb6473c759f18606d0388fe794c.pdf": 30104,
	"./CSpdf-d63b44dec48c90eb5d0be8cde49f3c4b.pdf": 22994,
	"./Corrigendum 2.pdf": 80283,
	"./Corrigendum of tender for Redesigning and Maintenance of the Official Website of NMDFC.pdf": 71411,
	"./Corrigendum of tender for empanelment of Event Management Agencies (EMA).pdf": 16108,
	"./EA-Resultpdf-e1c42c7590924542dc8249503f09de90.pdf": 48489,
	"./EMPANELMENT OF EVENT MANAGEMENT AGENCIES-EMAs.pdf": 18482,
	"./FAQ 31.07.2026.pdf": 63793,
	"./FAQ-FINALpdf-fd0709dda41b44f18057e80b5ab30960.pdf": 80754,
	"./NMDFCInternshipSchemePDF-f254d6290c851de5899533dc2338dfe3.pdf": 5947,
	"./Notice inviting tenders for conducting Socio Economic Impact Study of beneficiaries financed under various schemes of NMDFC.pdf": 97025,
	"./Proposal for Kaushal se Kushalta Scheme.pdf": 28526,
	"./Redesigning and Maintenance of the Official Website of NMDFC for One Year.pdf": 75956,
	"./Test-resultscorepdf-a816ce79e5364ec5100a6a43e9c812c7.pdf": 70945,
	"./UpdatedResultDeclarationofExamconductedon28092025DirectRecruitmentBasisPDF-734d41d528eab26406cf232c1a3abbcf.pdf": 66972,
	"./YPpdf-d646317c0d2af7a6cf5e0dfee83ed44d.pdf": 1926,
	"./consultant-MFpdf-aa22f42012e2a775e26589266f70e91e.pdf": 92792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30284;